import { Component, OnInit, ErrorHandler } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RegistrationService } from '../../../registration.service';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';

@Component({
  selector: 'app-pension-issuing-authority-form',
  templateUrl: './pension-issuing-authority-form.component.html',
  styleUrls: ['./pension-issuing-authority-form.component.css']
})
export class PensionIssuingAuthorityFormComponent implements OnInit {
  maintitle="Pension Issuing Authority";
  title = "Add Pension Issuing Authority";
  p:any={};
  s:any={};
  c:any={};
  data: any;
  ServiceTypes: any=[];
  ServiceCategories: any=[];
  formInvalid: boolean;
  mode:any="save";
  PIA_Id: any;
  formSubmitted: boolean;
  constructor(private route: ActivatedRoute,private router: Router,private errorHandler:ErrorHandler,private userService: RegistrationService) { }

  ngOnInit() {
    this.GetAllServiceTypes();
    this.GetAllServiceCategories();
  //From URL
  this.mode=localStorage.getItem('mode');
  this.PIA_Id= localStorage.getItem('PIA_Id');
  localStorage.removeItem('PIA_Id'); 
  localStorage.removeItem('mode');
  
  if (this.PIA_Id != null && this.mode!=null) 
    this.GetPensionAuthorityDetailsById(this.PIA_Id);
  }

  GetPensionAuthorityDetailsById(PIA_Id) {
    document.getElementById('loader-spinner').style.display = "block";
   this.userService.getPensionAuthorityDetailsById(PIA_Id)
   .subscribe(
     (data:any) => {
       this.s = data.Result;
       document.getElementById('loader-spinner').style.display = "none";
     }, (error) => {
       document.getElementById('loader-spinner').style.display = "none";
       this.errorHandler.handleError(error);
     });
}

   //Service type dropdown
   GetAllServiceTypes() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.getAllServiceTypes();
    this.data.subscribe(
      (response) => {
        this.ServiceTypes = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        //console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
  }
  
  
//Service category dropdown
  GetAllServiceCategories() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.getAllServiceCategories();
    this.data.subscribe(
      (response) => {
        this.ServiceCategories = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        //console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
  }


   //Save
 SavePensionIssuingAuthorityDetails(PIAform: NgForm) {    
  
 // alert(this.s.SR_PA_Pincode.getRawValue());
   if (PIAform.valid) {
    this.formInvalid = false;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.savePensionIssuingAuthorityDetails(PIAform.value);
    this.data.subscribe(
      (response) => {
        PIAform.reset();
        PIAform.resetForm();       
        swal('Success!', 'PensionIssuingAuthority details saved Successfully.', 'success');
        this.router.navigate(['/home/PensionIssuingAuthority']) ;   
        document.getElementById('loader-spinner').style.display = "none";        
      }, (error) => {
         document.getElementById('loader-spinner').style.display = "none";
            if (error.status == 401) {
              this.errorHandler.handleError(error);
            }
            else if (error.status == 400) {
              swal('Warning!', error.error.Message, 'warning');
            }
      });
  }
  else {
    swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
    this.formInvalid = true;
  }
}

//Update
UpdatePensionIssuingAuthorityDetails(PIAform: NgForm) {
  if (!PIAform.invalid) {
  document.getElementById('loader-spinner').style.display = "block";
  this.userService.updatePensionIssuingAuthorityDetails(PIAform.value,this.PIA_Id)
    .subscribe(
      (data) => {
        document.getElementById('loader-spinner').style.display = "none";
        swal('','Updated Successfully!','success');
        this.router.navigate(['/home/PensionIssuingAuthority']); 
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.handleError(error);
        //swal('Warning!', error.error.Message, 'warning');
      });
    }else{
      document.getElementById('loader-spinner').style.display = "none";
      swal('warning','Please fill all the mandatory fields!','warning');
      this.formSubmitted = true;

      }
}

}



// WEBPACK FOOTER //
// ./src/app/Masters/Pension-Issuing-Authority/pension-issuing-authority-form/pension-issuing-authority-form.component.ts